var carouselTag = "custom-carousel"

function carouselNext(btn) {
    carousel = btn.parentNode.parentNode;
    loop(carousel);
}

function carouselPast(btn) {
    carousel = btn.parentNode.parentNode;
    items = carousel.getElementsByClassName("item");
    current_index = parseInt(carousel.getAttribute("index"));
    const options = carousel.getAttribute("scroll").split(" ");
    vertical = options.indexOf('horizontal') < 0;

    if (current_index > 0) {
        current_index = current_index - 1;
    } else {
        current_index = getLastVisibleIndex(carousel, vertical);
    }

    carousel.setAttribute("index", current_index);
}

//this fella might not work properly
function getLastVisibleIndex(carousel, vertical) {
    items = carousel.getElementsByClassName("item");
    index = items.length;
    var values = vertical ? ['top', 'height', 'offsetHeight'] : ['left', 'width', 'offsetWidth'];

    for (var i = 0; i < items.length; i++) {
      var windowHeight = carousel.getBoundingClientRect()[values[0]] + carousel[values[2]] - items[i].getBoundingClientRect()[values[1]];
      var elementTop = items[i].getBoundingClientRect()[values[0]];
      if (elementTop < windowHeight) {
          index = index - 1;
      } else {
          break;
      }
    }

    return Math.min(index, items.length - 1);
}

function carouselNav(btn) {
    carousel = btn.parentNode.parentNode.parentNode;
    carousel.setAttribute("index", btn.getAttribute("index"));
}

function loop(carousel) {
    items = carousel.getElementsByClassName("item");
    current_index = parseInt(carousel.getAttribute("index"));
    const options = carousel.getAttribute("scroll").split(" ");
    vertical = options.indexOf('horizontal') < 0;
    scroll = vertical ? ['scrollTop', 'scrollHeight', 'clientHeight'] : ['scrollLeft', 'scrollWidth', 'clientWidth'];

    if (current_index < items.length - 1 && carousel[scroll[0]] < carousel[scroll[1]] - carousel[scroll[2]]) {
        current_index = current_index + 1;
    } else {
        current_index = 0;
    }

    carousel.setAttribute("index", current_index);
}

document.addEventListener('DOMContentLoaded',
    function () {
        var carousels = document.getElementsByTagName(carouselTag);

        function animate(carousel) {
            const options = carousel.getAttribute("scroll").split(" ");
            vertical = options.indexOf('horizontal') < 0;
            animateStart = options.indexOf('animateStart') > -1;
            items = carousel.getElementsByClassName("item");
            var values = vertical ? ['top', 'height', 'offsetHeight'] : ['left', 'width', 'offsetWidth'];
            for (var i = 0; i < items.length; i++) {
              var windowTop = carousel.getBoundingClientRect()[values[0]]
              var windowHeight = carousel.getBoundingClientRect()[values[0]] + carousel[values[2]] - items[i].getBoundingClientRect()[values[1]];
              var elementTop = items[i].getBoundingClientRect()[values[0]];
              var elementHeight = animateStart ? 0 : items[i][values[2]] / 2
              if (elementTop < windowHeight && elementTop + elementHeight > windowTop) {
                  items[i].classList.add("active");
              } else {
                  items[i].classList.remove("active");
              }
            }
        }

        function handleResponse(xml, carousel) {
            var jsonStr = xml.responseText;
            var jsonObj = JSON.parse(jsonStr);
            const dotCount = carousel.getElementsByClassName("item").length;
            const dummyDocument = document.createElement("html");

            const options = carousel.getAttribute("scroll").split(" ");
            dummyDocument.innerHTML = jsonObj['carousel-controls'];
            const controls = dummyDocument.getElementsByTagName("div")[0];
            controls.style.height = carousel.getBoundingClientRect().height + "px";
            controls.style.width = carousel.getBoundingClientRect().width + "px";

            if (dotCount > 1 && options.indexOf('dots') >= 0) {
                const dotsDiv = dummyDocument.getElementsByClassName("dots")[0];
                dotsDiv.innerHTML += "<button class='active' onclick='carouselNav(this)' index='0'></button>"
                for (var i = 1; i < dotCount; i++) {
                    dotsDiv.innerHTML += "<button onclick='carouselNav(this)' index='" + i + "'></button>";
                }
            }

            carousel.innerHTML += dummyDocument.innerHTML;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(m => {
                if (m.type = "attributes" && m.attributeName == "index") {
                    const carousel = m.target;
                    const options = carousel.getAttribute("scroll").split(" ");
                    var index = parseInt(carousel.getAttribute("index"));
                    vertical = options.indexOf('horizontal') < 0;
                    var values = vertical ? ['scrollTop'] : ['scrollLeft'];
                    var items = carousel.getElementsByClassName("item");

                    if (options.indexOf('dots') >= 0) {
                        const dotsDiv = m.target.getElementsByClassName("dots")[0];
                        const deactivate = dotsDiv.getElementsByClassName("active")[0];
                        deactivate.classList.remove("active");
                        const dots = dotsDiv.getElementsByTagName("button");
                        for (dot of dots) {
                            if (dot.getAttribute("index") == index) {
                                dot.classList.add("active");
                                break;
                            }
                        }
                    }

                    carousel[values[0]] = vertical ? items[index].offsetTop : items[index].offsetLeft;
                }
            })
        })

        var config = { attributes: true, attributeFilter: ['index'] }

        for (const carousel of carousels) {
            const options = carousel.getAttribute("scroll").split(" ");
            vertical = options.indexOf('horizontal') < 0;
            carousel.style.display = "flex";
            carousel.style.scrollBehavior = "smooth";
            carousel.style.overflow = "scroll";
            carousel.setAttribute("index", 0);

            observer.observe(carousel, config);

            if (vertical) {
                carousel.style.flexDirection = "column";
                carousel.style.alignItems = "unset";
            } else {
                carousel.style.flexDirection = "row";
                carousel.style.justifyContent = "unset";
            }

            if (options.indexOf('no-controls') < 0) {
                const request = new XMLHttpRequest();

                request.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        handleResponse(this, carousel);
                    }
                };

                request.open('GET', '/?sections=carousel-controls', true);
                request.send();
            }

            if (options.indexOf('animated') >= 0) {
                animate(carousel);
                func = function () { animate(carousel) };

                carousel.addEventListener('scroll', func);
            }
            if (options.indexOf('auto') >= 0) {
                speed = carousel.getAttribute("speed") == null ? 5000 : carousel.getAttribute("speed");
                beginInterval(carousel, speed, options.indexOf('stop-on-hover') >= 0)
            }
        }

        function beginInterval(carousel, speed, stopOnHover) {
            if (stopOnHover) {
                carousel.addEventListener('mouseover', function () { cancelInterval(carousel) });
                carousel.addEventListener('mouseout', function () { beginInterval(carousel, speed) });
            }
            carousel.setAttribute('interval', setInterval(function () { loop(carousel) }, speed));
        }

        function cancelInterval(carousel) {
            clearInterval(parseInt(carousel.getAttribute('interval')));
        }
    }
)
